import { create } from 'zustand';

const useSubscriptionStore = create((set) => ({
    subscription: null,
    isLoading: true,
    isDemo: false,
    isEssential: false,
    isUltimate: false,
    setSubscription: (subscription) => set({ subscription }),
    setIsLoading: (isLoading) => set({ isLoading }),
    setIsDemo: (isDemo) => set({ isDemo }),
    setIsEssential: (isEssential) => set({ isEssential }),
    setIsUltimate: (isUltimate) => set({ isUltimate }),
}));

export default useSubscriptionStore;
